import React from 'react'
import Header from '../../Layout/Header'
import Footer from '../../Layout/Footer'
import FAQ from './FAQ'
import SeoTagsFooter from './SeoTagsFooter'

function Career() {
  return (
    <div className="page_wrapper">
        <Header/>
          <main className="page_content">


<section className="page_header text-center bg-dark section_decoration overflow-hidden" style={{backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')"}}>
  <div className="container">
    <h1 className="page_title text-white">Career Opportunities</h1>
    <ul className="breadcrumb_nav unordered_list justify-content-center">
      <li><a href="/">Home</a></li>
      <li className="active"><a href="#!">Career</a></li>
    </ul>
  </div>
  <div className="decoration_item shape_nate">
    <img src="assets/images/shapes/shape_nate.svg" alt="Shape Nate"/>
  </div>
</section>

<section className="career_section section_space bg-light">
  <div className="container">
    <div className="heading_block text-center">
      <h2 className="heading_text mb-2 text-dark">
        Build the Future of Fintech with Mokshiq
      </h2>
      <p className="text-dark">
        Mokshiq (a product of <strong>Rakle Service Private Limited</strong>) is hiring passionate engineers, product managers, and fintech specialists. Send your CV to <a href="mailto:career@mokshiq.in" className="text-primary fw-bold">career@mokshiq.in</a> or call <a href="tel:+917311104571" className="text-primary fw-bold">+91 7311104571</a>.
      </p>
    </div>

    <div className="filter_elements_nav justify-content-center">
      <ul className="unordered_list">
        <li className="active" data-filter="all"><button style={{ color: '#012A2B' }}>View All</button></li>
        <li data-filter="development"><button style={{ color: '#012A2B' }}>Development</button></li>
        <li data-filter="design"><button style={{ color: '#012A2B' }}>Design</button></li>
        <li data-filter="marketing"><button style={{ color: '#012A2B' }}>Marketing</button></li>
        <li data-filter="customerservices"><button style={{ color: '#012A2B' }}>Customer Services</button></li>
      </ul>
    </div>
    <div className="filter_elements_wrapper">
      <div className="career_block development mb-3 p-4 bg-white rounded shadow-sm d-flex justify-content-between align-items-center">
        <div className="career_info">
          <h3 className="block_title text-dark m-0">
            Senior Full Stack Engineer (Node.js &amp; React)
          </h3>
          <ul className="iconlist_block unordered_list text-dark small mt-2">
            <li className="me-3"><i className="fa-solid fa-location-dot me-1"></i>Noida Sector-2 / Remote</li>
            <li><i className="fa-solid fa-clock me-1"></i>Full-time</li>
          </ul>
        </div>
        <a className="btn text-dark btn-outline-primary" href="/join_us">
          <span className="btn_label">Apply Now</span>
          <span className="btn_icon ms-2"><i className="fa-solid fa-arrow-up-right"></i></span>
        </a>
      </div>

      <div className="career_block development mb-3 p-4 bg-white rounded shadow-sm d-flex justify-content-between align-items-center">
        <div className="career_info">
          <h3 className="block_title text-dark m-0">
            API Integration &amp; Security Specialist (Verify)
          </h3>
          <ul className="iconlist_block unordered_list text-dark small mt-2">
            <li className="me-3"><i className="fa-solid fa-location-dot me-1"></i>Noida Sector-2</li>
            <li><i className="fa-solid fa-clock me-1"></i>Full-time</li>
          </ul>
        </div>
        <a className="btn text-dark btn-outline-primary" href="/join_us">
          <span className="btn_label">Apply Now</span>
          <span className="btn_icon ms-2"><i className="fa-solid fa-arrow-up-right"></i></span>
        </a>
      </div>

      <div className="career_block marketing mb-3 p-4 bg-white rounded shadow-sm d-flex justify-content-between align-items-center">
        <div className="career_info">
          <h3 className="block_title text-dark m-0">
            Fintech Product Manager (AEPS &amp; DMT Solutions)
          </h3>
          <ul className="iconlist_block unordered_list text-dark small mt-2">
            <li className="me-3"><i className="fa-solid fa-location-dot me-1"></i>Noida Sector-2</li>
            <li><i className="fa-solid fa-clock me-1"></i>Full-time</li>
          </ul>
        </div>
        <a className="btn text-dark btn-outline-primary" href="/join_us">
          <span className="btn_label">Apply Now</span>
          <span className="btn_icon ms-2"><i className="fa-solid fa-arrow-up-right"></i></span>
        </a>
      </div>
    </div>
  </div>
</section>

<FAQ 
  title="Career & Hiring FAQs"
  subtitle="Questions about interviewing, workplace culture, or technical roles at Mokshiq?"
/>

</main>
<Footer/>
<SeoTagsFooter/>
        </div>
  )
}

export default Career